import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GrupoProdutoService {
  private data = null;
  private url = environment.serviceApi;
  constructor(public http: Http) { }

  getGruposProdutoCadastro() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoprodutoCadastro')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getGruposProduto() {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoproduto')
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  getGrupoProduto(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.url + '/grupoproduto/' + id)
        .map(res => res.json())
        .subscribe(data => {
          this.data = data;
          resolve(this.data);
        },
          err => {
            reject(err);
          });
    });
  }

  criaGrupoProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/grupoproduto', {
				grupo_produto_nome: data.grupo_produto_nome,
				grupo_produto_lote: data.grupo_produto_lote,
				grupo_produto_lote_nome: data.grupo_produto_lote_nome,
				grupo_produto_data_validade: data.grupo_produto_data_validade,
				grupo_produto_status: data.grupo_produto_status
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaGrupoProduto(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/grupoproduto/' + data.grupo_produto_id, {
				grupo_produto_nome: data.grupo_produto_nome,
				grupo_produto_lote: data.grupo_produto_lote,
				grupo_produto_lote_nome: data.grupo_produto_lote_nome,
				grupo_produto_data_validade: data.grupo_produto_data_validade,
				grupo_produto_status: data.grupo_produto_status				
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaGrupoProduto(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/grupoproduto/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
